import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { AlertCircleIcon } from 'lucide-react';
interface Slide10Props {
  onNavigate: (slide: number) => void;
}
export function Slide10({
  onNavigate
}: Slide10Props) {
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." onBack={() => onNavigate(7)} data-id="element-61">
      <div className="w-full max-w-4xl mx-auto space-y-12" data-id="element-62">
        <h1 className="text-4xl font-bold text-white text-center mb-8 uppercase" data-id="element-63">
          PREGNANCY CONSIDERATIONS
        </h1>
        <div className="frosted-card rounded-2xl shadow-xl p-12" data-id="element-64">
          <div className="flex items-start gap-8" data-id="element-65">
            <div className="flex-shrink-0" data-id="element-66">
              <div className="w-20 h-20 bg-[#0E8585] rounded-full flex items-center justify-center shadow-lg" data-id="element-67">
                <AlertCircleIcon className="w-10 h-10 text-white" data-id="element-68" />
              </div>
            </div>
            <div className="flex-1" data-id="element-69">
              <p className="text-2xl text-white font-medium leading-relaxed" data-id="element-70">
                Women of childbearing potential should use effective
                contraception during treatment and for 3 months after the last
                dose, as outlined in the SmPC.
                <sup data-id="element-71">¹</sup>
              </p>
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}